import { Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import './theme.css';
import AppShell from './components/AppShell';
import HomePage from './pages/HomePage';
import CampaignDashboard from './dashboards/CampaignDashboard';
import CampaignsLiveDashboard from './dashboards/campaignsLive/CampaignsLiveDashboard';
import EmsDashboard from './dashboards/ems/EmsDashboard';
import OnboardingDashboard from './dashboards/onboarding/OnboardingDashboard';
import ClientsPage from './pages/ClientsPage';
import InternalUsersPage from './pages/InternalUsersPage';
import DisputeConsolePage from './pages/DisputeConsolePage';
import { CampaignDataProvider } from './dashboards/CampaignDataContext';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import LoginScreen from './components/LoginScreen';
import { allowedPathsForRole, landingPathForRole } from './config/access';

// Every module, keyed by the path the access rules refer to.
const ROUTES = [
  { path: '/campaigns', element: <CampaignsLiveDashboard /> },
  { path: '/ems', element: <EmsDashboard /> },
  { path: '/onboarding', element: <OnboardingDashboard /> },
  { path: '/clients', element: <ClientsPage /> },
  { path: '/internal-users', element: <InternalUsersPage /> },
  { path: '/dispute-console', element: <DisputeConsolePage /> },
  // The pre-live snapshot dashboard. Off the nav but still routable so the old
  // invoice_funnel_metrics numbers can be pulled up alongside the live ones.
  { path: '/campaigns-snapshot', element: <CampaignDashboard /> },
];

function AuthenticatedApp() {
  const { currentUser } = useAuth();
  if (!currentUser) return <LoginScreen />;

  // Restricted roles (EXECUTIVE) see only their allow-listed modules — EMS,
  // Campaigns and the Dispute Console; every other path redirects to the first
  // one they can reach. Sidebar visibility is gated separately, and the backend
  // remains the real security boundary.
  const allowed = allowedPathsForRole(currentUser.role);
  const visible = allowed
    ? ROUTES.filter(r => allowed.includes(r.path))
    : ROUTES;
  const fallback = allowed ? landingPathForRole(currentUser.role) : '/';

  return (
    <CampaignDataProvider>
      <Routes>
        <Route element={<AppShell />}>
          {!allowed && <Route index element={<HomePage />} />}
          {visible.map(r => (
            <Route key={r.path} path={r.path.slice(1)} element={r.element} />
          ))}
          <Route path="*" element={<Navigate to={fallback} replace />} />
        </Route>
      </Routes>
    </CampaignDataProvider>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <AuthenticatedApp />
    </AuthProvider>
  );
}
